// Vue-direktivet v-drag-and-drop-events.
//
// binding.value (attributets satta värde) ska vara ett objekt enligt följande definition (här med exempelvärden):
//		{
//			listening: true,		// Om det ska lyssnas efter drag and drop-events eller inte.
//			eventHandler: (e) => onDnd(vpIndex, e.deltaX, e.deltaY, e.isFinal, e)
//		}

import Hammer from 'hammerjs';


const directive = {

	name: 'drag-and-drop-events',

	// called only once, when the directive is first bound to the element. This is where you can do one-time setup work.
	bind(el, binding, vnode) {
		//console.log('id=' + vnode.context._self._uid + ' : BIND, value = ' + binding.value.listening);

		if (typeof binding.value.eventHandler === 'function') {

			// #######################################################################
			// Helpers:

			// Läggs under vnode.context för att kunna nås även från andra delar av detta directive, event handler etc:
			vnode.context.isInitialUpdate = true;
			vnode.context.hammerMc = null;
			vnode.context.panstarted = false;

			// Läggs under vnode.context för att kunna nås även från andra delar av detta directive, event handler etc:
			vnode.context.onEvent = function(e) {

				// Todo: workaround införd med brute force-fuling:
				// Ibland (vid snabb initial släpning) så avfyras aldrig något "panstart". Sekvensen inleds istället med en "panmove", isFirst=1, och det verkar inte heller komma en "panstart" omedelbart efter (fel ordning). Min brutala fix här: Jag sätter helt enkelt om e.type till det egna 'panstart-virtuellt-custom' i detta case (och ändrar *inga* andra prop, exempelvis eventType):
				if (e.type == 'panmove' && e.isFirst)
					e.type = 'panstart-virtuellt-custom';

				//console.log(`Event ${e.type}: `, e, this);

				switch (e.type) {
					case 'panstart':
					case 'panstart-virtuellt-custom':
					{
						vnode.context.panstarted = true;
						vnode.context.startaEsclyssning();

						// Skicka vidare Hammer-eventet:
						binding.value.eventHandler(e);

						// Generera direkt därefter ett "virtuellt" move-event (särskilt som ett äkta move kan ha gjort som till panstart-virtuellt-custom ovan):
						// Jag sätter helt enkelt om e.type till det egna 'panmove-virtuellt-custom' (och ändrar *inga* andra prop, exempelvis eventType) och emittar även det:
						// Eventet måste först clonas, annars sätter jag om de data som följer med i pan-start*-emitten ovan!!
						//let eClone = JSON.parse(JSON.stringify(e));
						// Och det visade sig såklart lättare sagt än gjort, då den innehåller circular references :(
						// Kör istället med ett *custom* special-Hammer-"event" *utan* andra properties än de som jag vet behövs i euiPositioneradPanelcontainer:
						// Skicka vidare "Hammer-eventet":
						binding.value.eventHandler({
							type: 'panmove-virtuellt-custom',
							deltaX: e.deltaX,
							deltaY: e.deltaY,
							center: {
								x: e.center.x,
								y: e.center.y
							},
						});

						break;
					}

					case 'panmove':
					{
						if (vnode.context.latestMoveMouseXY.x != e.center.x
							|| vnode.context.latestMoveMouseXY.y != e.center.y)
						{
							// Bara om muspositionen verkligen har flyttat sig (hela pixlar):

							// Spara undan senaste registrerade muskoordinater för ett move-event:
							vnode.context.latestMoveMouseXY = { x: e.center.x, y: e.center.y };

							// Skicka vidare Hammer-eventet:
							binding.value.eventHandler(e);
						}
						else
						{
							//console.log('#### panmove utan ändrad pos helt bortfiltrerat');
						}

						break;
					}

					// Inte längre pancancel. Den skickas i tid och otid och det är för mig oklart vad exakt den innebär!
					// Vid senare tester skickas den *inte* i tiod och otid (får den inte alls faktiskt). Viss extern exempelkod antyder att den inträffar när musen läm,nar objektet (man drar för snabbt) eller när musen lämnar containern/skärmen eller nåt sånt. Hanterar den tills vidare identiskt med panend
					//case 'pancancel':
					//	eventName = 'itemDraggingCanceled';
					//	break;
					case 'pancancel':
					case 'panend':
					{
						// Todo: workaround för bug (?) i Hammer i detta case:
						// Om man släpar i en rullningslist inom dnd-elementet så sänds inga event, men när man *släpper* så kommer det ett ensamt panend. Det ignorerar vi härmed:
						if (!vnode.context.panstarted)
							break;

						vnode.context.panstarted = false;
						vnode.context.latestMoveMouseXY = { x: 0, y: 0 };
						vnode.context.stoppaEsclyssning();

						// Skicka vidare Hammer-eventet:
						binding.value.eventHandler(e);

						break;
					}

					default:
					{
						console.error('Ogiltigt pan-event detekterat!');
					}
				}
			};

			// Läggs under vnode.context för att kunna nås även från andra delar av detta directive, event handler etc:
			vnode.context.stoppaHammerSessionOchEsclyssnaren = () => {

				// Stoppa Hammer:
				vnode.context.hammerMc.stop(true);	// Stop recognizing for this session. true = force

				// Avveckla Esc-lyssningen:
				vnode.context.stoppaEsclyssning();
			};

			// Läggs under vnode.context för att kunna nås även från andra delar av detta directive, event handler etc:
			vnode.context.startaEsclyssning = function() {

				// var that = this;
				// window.addEventListener('keydown', function(e) {return that.someMethod(e);});

				document.addEventListener('keydown', vnode.context.onKeydown, { capture: true });	// Capture!
				//console.log('Esc-lyssning aktiverad');
			};

			// Läggs under vnode.context för att kunna nås även från andra delar av detta directive, event handler etc:
			vnode.context.stoppaEsclyssning = function() {
				document.removeEventListener('keydown', vnode.context.onKeydown, { capture: true });	// Capture!		// Hur f-n kunde funka när denna var så här: , this.onKeydown);? Är 'vnode.context' == 'this'??
				//console.log('Esc-lyssning deaktiverad');
			};

			// Läggs under vnode.context för att kunna nås även från andra delar av detta directive, event handler etc:
			vnode.context.onKeydown = function(e) {
				//console.log('onKeydown');

				if (!e.defaultPrevented
					&& !e.repeat
				)
				{
					//console.log(`Tangent: key="${e.key}", keycode=${e.keyCode}, key.charCodeAt(0)=${e.key.charCodeAt(0)}`, e);

					if (!e.altKey				// NO! Alt + ..
						&& !e.ctrlKey			// NO! Ctrl + ..
						&& e.keyCode === 27	// Esc
					)
					{
						// Cancel the default action to avoid it being handled twice
						e.preventDefault();

						vnode.context.stoppaHammerSessionOchEsclyssnaren();
						vnode.context.latestMoveMouseXY = { x: 0, y: 0 };

						// Detta är ett *custom* special-Hammer-"event" *utan* andra properties än "type":
						// Skicka vidare "Hammer-eventet":
						binding.value.eventHandler({ type: 'panavbruten-custom' });
					}
				}
			};


			// #### HÄRIFRÅN!

		}
		else
		{
			console.error('Parametern till v-drag-and-drop-events måste vara en metod som tar hand om dnd-eventen.')
		}

	},

	// called when the bound element has been inserted into its parent node (this only guarantees parent node presence, not necessarily in-document).
	inserted(el, binding, vnode) {
		//console.log('id=' + vnode.context._self._uid + ' : INSERTED, value = ' + binding.value.listening);
	},

	// called after the containing component’s VNode has updated, but possibly before its children have updated. The directive’s value may or may not have changed, but you can skip unnecessary updates by comparing the binding’s current and old values (see below on hook arguments).
	update(el, binding, vnode, oldVnode) {
		//console.log('id=' + vnode.context._self._uid + ' : UPDATE, value = ' + binding.oldValue.listening + ' –> ' + binding.value.listening);

		if (vnode.context.isInitialUpdate
			|| binding.value.listening !== binding.oldValue.listening)
		{
			if (binding.value.listening)
			{
				// #######################################################################
				// Själva bindningen:

				// Läggs under vnode.context för att kunna nås även från andra delar av detta directive, event handler etc:
				vnode.context.panstarted = false;

				// Initiera senaste registrerade muskoordinater:
				vnode.context.latestMoveMouseXY = { x: 0, y: 0 };


				// Denna behövdes av ngn anledning för att jag inte skulle få en pancancel strax efter panstart på touch (i Chrome desktop).
				// Se https://stackoverflow.com/a/50878715/593779.
				// Jag lät andra försök att lösa detta ligga kvar, trots att de i sig inte verkade hjälpa, som ex.vis:
				// ._eui-positionerad-panelcontainer.-is-beeing-dragged *
				// {
				//		pointer-events: none !important;
				//		touch-action: none !important;
				//	}
				//const options = { passive: false }; // needed because Chrome has this set to "true" by default for "touchmove" events
				//el.addEventListener('touchmove', e => {
				//		if (binding.value.listening)
				//			e.preventDefault();
				//	},
				//	options
				//);

				const mc = new Hammer(el, {
					recognizers: [
						// If you’ll pass an empty recognizer option, no initial recognizers will be added.
						// Inga här (annars blir det en defaultuppsättning). Adderas manuellt nedan istället:

						// RecognizerClass, [options], [recognizeWith, ...], [requireFailure, ...]
						//[Hammer.Rotate],
						//[Hammer.Pinch, { enable: false }, ['rotate']],
						//[Hammer.Swipe, { direction: Hammer.DIRECTION_HORIZONTAL }],
					]
				});

				// Using set(options) to change an option on the manager instance is recommended, because it will update the touchAction value if needed:
				mc.set({
					enable: true,	//binding.value.listening,
					domEvents: true
				});

				//mc.get('pan').set({ direction: Hammer.DIRECTION_ALL });
				// Exempelkod: Annat sätt för add: mc.add(new Hammer.Tap({enable: canEnable}));
				mc
					.add(new Hammer.Pan())	//'pan')
					.set({
						threshold: 3,
						direction: Hammer.DIRECTION_ALL,
					});

				// Events
				// pan, together with all of below
				// panstart
				// panmove
				// panend
				// pancancel
				// panleft
				// panright
				// panup
				// pandown

				// Sätter här alla events som vi kan vilja urskilja på högre nivå:
				//mc.on('panstart panmove panend pancancel', binding.value.eventHandler);	//onEvent);
				mc.on('panstart panmove panend pancancel', vnode.context.onEvent);

				// Spara undan mc för att kunna ändra den sen, i update:
				// vnode.context will give you access to the data properties on the Vue instance:
				//vnode.$_hammerMc =
				// Läggs under vnode.context för att kunna nås även från andra delar av detta directive, event handler etc:
				vnode.context.hammerMc = mc;


				//vnode.context.hammerMc.set({ enable: binding.value.listening });
			}
			else
			{
				if (!vnode.context.isInitialUpdate)
				{
					// Ändrat till *not* listening:
					vnode.context.stoppaHammerSessionOchEsclyssnaren();

					var mc = vnode.context.hammerMc;
					mc.destroy();	// Destroy the manager and unbinds all events (it doesn't unbind dom events, that is the user own responsibility).
					vnode.context.hammerMc = null;
				}

			}
		}

		vnode.context.isInitialUpdate = false;
	},

	// called after the containing component’s VNode and the VNodes of its children have updated.
	componentUpdated(el, binding, vnode, oldVnode) {
		//console.log('id=' + vnode.context._self._uid + ' : COMPONENTuPDATE, value = ' + binding.oldValue.listening + ' –> ' + binding.value.listening);
	},

	// called only once, when the directive is unbound from the element.
	unbind(el, binding, vnode) {

		//vnode.context.stoppaHammerSessionOchEsclyssnaren();

		//var mc = vnode.context.hammerMc;
		//mc.destroy();	// Destroy the manager and unbinds all events (it doesn't unbind dom events, that is the user own responsibility).
		//vnode.context.hammerMc = null;
	},

};



//// För detta direktiv testar jag att alltid registrera det globalt, vid import:
//Vue.directive('drag-and-drop-events', directive);

// Rekommenderad användning:
// import euiDragAndDropEvents from 'v-directives/euiDragAndDropEvents';
// ...
//	directives: {
//		[euiDragAndDropEvents.name]: euiDragAndDropEvents,
//	},


export default directive;
